var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { mediatorSettings } from "../../index.js";
var OrderMappings = /** @class */ (function () {
    function OrderMappings() {
        this._mappings = [];
    }
    OrderMappings.prototype.add = function (mapping) {
        if (mapping.order !== 0) {
            mapping.order = this._mappings.length;
        }
        this._mappings.push(mapping);
        this.onAdded(mapping);
    };
    OrderMappings.prototype.clear = function () {
        this._mappings = [];
    };
    return OrderMappings;
}());
export { OrderMappings };
function byOrder(a, b) {
    return (b.order || 0) - (a.order || 0);
}
var NotificationMappings = /** @class */ (function (_super) {
    __extends(NotificationMappings, _super);
    function NotificationMappings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotificationMappings.prototype.onAdded = function (mapping) {
        var handlerName = mapping.handler.prototype.constructor.name;
        mediatorSettings.resolver.add(handlerName, mapping.handler);
    };
    NotificationMappings.prototype.setOrder = function (notification, handlers) {
        var all = this.getAll(notification);
        for (var _i = 0, all_1 = all; _i < all_1.length; _i++) {
            var handler = all_1[_i];
            handler.order = handlers.indexOf(handler.handler);
        }
    };
    NotificationMappings.prototype.getAll = function (notification) {
        var items = this._mappings.filter(function (p) { return p.notification === notification; });
        if (items.length === 0)
            throw new Error("Cannot find notification handler with key: ".concat(notification.prototype.name));
        return items.sort(byOrder);
    };
    return NotificationMappings;
}(OrderMappings));
export { NotificationMappings };
var BehaviorMappings = /** @class */ (function (_super) {
    __extends(BehaviorMappings, _super);
    function BehaviorMappings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BehaviorMappings.prototype.onAdded = function (mapping) {
        var handlerName = mapping.behavior.prototype.constructor.name;
        mediatorSettings.resolver.add(handlerName, mapping.behavior);
    };
    BehaviorMappings.prototype.setOrder = function (behaviors) {
        var all = this.getAll();
        for (var _i = 0, all_2 = all; _i < all_2.length; _i++) {
            var handler = all_2[_i];
            handler.order = behaviors.indexOf(handler.behavior);
        }
    };
    BehaviorMappings.prototype.getAll = function () {
        var items = __spreadArray([], this._mappings, true);
        return items.sort(byOrder);
    };
    return BehaviorMappings;
}(OrderMappings));
export { BehaviorMappings };
//# sourceMappingURL=mappings.js.map